import Page from "src/components/Page";
import useLocales from "src/hooks/useLocales";

import DemoContainer from "./DemoContainer";

// ----------------------------------------------------------------------

export const DemoTransactions = () => {
	const { translate } = useLocales();

	return (
		<Page title={translate("demo_demo_transactions")}>
			<DemoContainer type={"TRANSACTIONS"} />
		</Page>
	);
};

export default DemoTransactions;
